import angular from 'angular';

export default class StocksGestionRapportActiviteController {
	static $inject = [
		'$interval',
		'$scope',
		'$state',
		'$uibModal',
		'notification',
		'$translate',
		'$filter',
		'moment',
		'StocksGestionRapportActiviteService',
		'MassiaRightsService',
		'$location',
		'localStorageService',
		'ModalService',
		'MassiaAuthService'
	];

	constructor(
		$interval,
		$scope,
		$state,
		$uibModal,
		notification,
		$translate,
		$filter,
		moment,
		StocksGestionRapportActiviteService,
		MassiaRightsService,
		$location,
		localStorageService,
		ModalService,
		MassiaAuthService
	) {
		this.$interval = $interval;
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModal = $uibModal;
		this.notification = notification;
		this.$translate = $translate;
		this.$filter = $filter;
		this.moment = moment;
		this.StocksGestionRapportActiviteService = StocksGestionRapportActiviteService;
		this.MassiaRightsService = MassiaRightsService;
		this.$location = $location;
		this.localStorageService = localStorageService;
		this.ModalService = ModalService;
		this.MassiaAuthService = MassiaAuthService;
		this.gestionRapport = [];
		this.updateRapport = {
			idProduits: [],
			newTransferts: [],
			newAjustements: [],
			newProductions: [],
			newProductionDisplays: []
		};
		this.copySecteurRapport = [];
		this.produits = [];
	}

	async $onInit() {
		// Recuperation des params dans lurl : ?codeDomaineParam=GRAN => {GRAN ENR LIA}
		const { codeDomaineParam, labelDomaineParam } = this.$state.params;
		const pageModeParam = this.$state.current.ncyBreadcrumbLabel;

		// Si le code domaine est different de celui en local storage
		if (codeDomaineParam && codeDomaineParam !== this.localStorageService.get('STOCK_CODE_DOMAINE')) {
			// On met a jour du local storage
			this.localStorageService.set('STOCK_CODE_DOMAINE', codeDomaineParam);
			this.localStorageService.set('STOCK_LABEL_NIVEAU', labelDomaineParam);
		}

		if (pageModeParam && pageModeParam !== this.localStorageService.get('STOCK_PAGE_MODE')) {
			this.localStorageService.set('STOCK_PAGE_MODE', this.$state.current.ncyBreadcrumbLabel);
		}

		// On recupere les valeurs du local storage
		const codeDomaine = this.localStorageService.get('STOCK_CODE_DOMAINE');
		const labelDomaine = this.localStorageService.get('STOCK_LABEL_NIVEAU');
		const pageMode = this.localStorageService.get('STOCK_PAGE_MODE');

		this.title = this.$translate.instant('STOCKS_GESTION_RAPPORT_ACTIVITE.TITLE', { pageMode, labelDomaine });
		this.toMuchRapportsTooltip = this.$translate.instant('STOCKS_GESTION_RAPPORT_ACTIVITE.TO_MUCH_RAPPORTS');

		this.initData();
		this.btnRefreshMouvementStock = false;
		this.isClotureJour = false;
		this.isActive = false;
		this.isEdit = false;
		var path = this.$location.path();
		var parts = path.split('/');
		var dernierElement = parts[parts.length - 1];
		if (dernierElement == 'edit') this.isEdit = true;
		this.color = '#ccccccc';
		this.colorGreen = '#e6ffe6';
		this.colorDarkGreen = '#ccffcc';
		await this.loadSocietes();
		const societeId = this.localStorageService.get('STOCK_RAPPORT_ACTIVITES_CONSULT_SOCIETE_ID');
		if (this.societes.length > 0) {
			this.idSociete = societeId || this.societes[0].id;
			if (this.idSociete) {
				await this.loadSites();
			}
		}

		const grpSiteId = this.localStorageService.get('STOCK_RAPPORT_ACTIVITES_CONSULT_GRPSITE_ID');
		if (this.sites.length > 0) {
			this.idSite = grpSiteId || this.sites[0].id;
			await this.loadRapports(codeDomaine);
			this.idRapport = this.rapports && this.rapports.length > 0 ? this.rapports[0].id : null;
		}

		this.$scope.$watch('$ctrl.idSociete', async (newValue, oldValue) => {
			if (newValue !== oldValue) {
				this.localStorageService.set('STOCK_RAPPORT_ACTIVITES_CONSULT_SOCIETE_ID', newValue);
				await this.loadSites();
				this.initData();
				this.idSite = this.sites.length > 0 ? this.sites[0].id : null;
			}
		});
		this.$scope.$watch('$ctrl.idSite', async (newValue, oldValue) => {
			if (newValue !== oldValue) {
				this.localStorageService.set('STOCK_RAPPORT_ACTIVITES_CONSULT_GRPSITE_ID', newValue);
				await this.loadRapports(codeDomaine);
				this.initData();
				this.idRapport = this.rapports.length > 0 ? this.rapports[0].id : null;
			}
		});

		this.refreshMouvementProgressCtrl();
	}

	async $onDestroy() {
		//supprime linterval
		this.$interval.cancel(this.intervalMouv);
	}

	async loadSocietes() {
		this.startLoading();
		try {
			this.societes = await this.StocksGestionRapportActiviteService.getSocietes();
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async loadSites() {
		this.startLoading();
		try {
			this.sites = await this.StocksGestionRapportActiviteService.getSites(this.idSociete);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async loadRapports(codeDomaine) {
		if (!this.idSite) return;
		this.startLoading();
		try {
			this.rapports = await this.StocksGestionRapportActiviteService.getRapportsByCodeDomaine(codeDomaine, this.idSite);
			this.listRapportIds = [];
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async getGestionRapport() {
		this.startLoading();
		this.btnRefreshMouvementStock = false;

		this.initData();

		if (!this.idSite || !this.idRapport || !this.dateDebut || (!this.isEdit && !this.dateFin)) {
			this.stopLoading();
			this.notification.error('Filtre(s) manquant(s)');
			return;
		}

		if (this.idSite) {
			this.btnRefreshMouvementStock = true;
		}

		try {
			this.copySecteurRapport = [];
			await Promise.all(
				this.listRapportIds.map(async (rapport, indexRapport) => {
					const id = rapport.id;

					const rappAct = await this.StocksGestionRapportActiviteService.getGestionRapport(this.idSite, id, this.dateDebut, this.dateFin);

					this.arrondi = rappAct.arrondi;
					this.dateCloture = rappAct.dateCloture;
					this.copySecteurRapport.push(...rappAct.secteurs);
					this.produits[indexRapport] = rappAct.secteurs.flatMap((secteur) => secteur.lignes);

					this.isClotureJour = this.isJourCloture(rappAct, this.dateDebut);
					this.gestionRapport[indexRapport] = angular.copy(rappAct);
				})
			);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	isJourCloture(obj, dateStr) {
		// Convertir la date du format 'DD/MM/YYYY' en format ISO 8601 'YYYY-MM-DDT00:00:00'
		var parts = dateStr.split('/');
		var isoDateStr = parts[2] + '-' + parts[1] + '-' + parts[0] + 'T00:00:00';

		for (var i = 0; i < obj.dateActivites.length; i++) {
			if (obj.dateActivites[i].date === isoDateStr) {
				return obj.dateActivites[i].isCloture;
			}
		}
		return false;
	}

	async export() {
		this.startLoading();
		if (this.listRapportIds.length > 0) {
			const rapportIds = this.listRapportIds.map((rapport) => rapport.id);

			const isMultiRapport = rapportIds.length > 1;

			if (!this.idSite || !this.idRapport || !this.dateDebut || (!this.isEdit && !this.dateFin)) {
				this.stopLoading();
				this.notification.error('Filtre(s) manquant(s)');
				return;
			}

			try {
				const fileData = await this.StocksGestionRapportActiviteService.export(this.idSite, rapportIds, this.dateDebut, this.dateFin);
				if (fileData) {
					let fileName = 'RapportActivites.zip';
					if (!isMultiRapport) {
						const rapport = this.rapports.find((r) => r.id === this.idRapport);
						fileName = rapport ? `${rapport.label}.xlsx` : 'RapportActivite.xlsx';
					}

					const blob = new Blob([fileData.data], {
						type: fileData.headers()['content-type'] + ';charset=UTF-8'
					});
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = fileName;

					link.dispatchEvent(
						new MouseEvent('click', {
							view: window,
							bubbles: true,
							cancelable: false
						})
					);
				}
			} catch (ex) {
				this.notification.error(ex.data);
			} finally {
				this.stopLoading();
			}
		}
	}

	initData() {
		this.gestionRapport = [];
		this.produits = [];

		this.updateRapport = {
			idProduits: [],
			newTransferts: [],
			newAjustements: [],
			newProductions: [],
			newProductionDisplays: []
		};
	}

	changeLigne(ligne, type, idRapport, idSecteur) {
		let modifiedSecteur = this.copySecteurRapport.find((x) => x.entete.idRapport == idRapport && x.entete.idSecteur == idSecteur);

		let ligneAvantModif = modifiedSecteur.lignes.find((x) => x.idProduit == ligne.idProduit && x.idProducteur == ligne.idProducteur);
		//un produit composé ne peut faire de productionClassique négative
		if (ligne.isProduitCompose && ligne.productionClassique < 0) {
			ligne.productionClassique = ligneAvantModif.productionClassique;
			this.opentModalAlert();
			return;
		}

		switch (type) {
			case 3:
				this.handleProduction(ligne, ligneAvantModif, idRapport);
				break;
			case 6:
				this.handleTransfert(ligne, ligneAvantModif, idRapport);
				break;
			case 7:
				this.handleAjustement(ligne, ligneAvantModif, idRapport);
				break;
			default:
				break;
		}

		var { newTransferts, newAjustements, newProductions } = angular.copy(this.updateRapport);
		this.isActive = newTransferts.length > 0 || newAjustements.length > 0 || newProductions.length > 0;
	}

	handleProduction(ligne, ligneAvantModif, idRapport) {
		let quantite = ligne.productionClassique - ligneAvantModif.productionClassique;

		//on regarde si il y a une ligne avec le même produit
		let ligneExist = this.updateRapport.newProductions.find(
			(x) => x.idProduit == ligne.idProduit && x.idSiteProducteur == ligne.idProducteur && x.mouvement === 3 && x.idRapport === idRapport
		);
		if (ligneExist) {
			this.removeFromArray(this.updateRapport.newProductions, ligneExist);
		}
		let ligneDisplayExist = this.updateRapport.newProductionDisplays.find(
			(x) => x.idProduit == ligne.idProduit && x.idSiteProducteur == ligne.idProducteur && x.mouvement === 3 && x.idRapport === idRapport
		);
		if (ligneDisplayExist) {
			if (ligneDisplayExist.compo.length > 0) {
				for (var index1 = 0; index1 < ligneDisplayExist.compo.length; index1++) {
					let currentCompo = ligneDisplayExist.compo[index1];
					this.removeFromArray(this.updateRapport.newProductions, currentCompo);
				}
			}

			this.removeFromArray(this.updateRapport.newProductionDisplays, ligneDisplayExist);
		}

		if (ligne.productionClassique !== ligneAvantModif.productionClassique) {
			let newProduction = {
				idProduit: ligne.idProduit,
				codeProduit: ligne.codeProduit,
				libelleProduit: ligne.libelleProduit,
				idSiteProducteur: ligne.idProducteur,
				siteProducteur: ligne.siteProducteur,
				mouvement: 3,
				quantite: quantite,
				unite: ligne.unite,
				estSortie: false,
				idProduitCompare: ligne.idProduit + '_' + ligne.idProducteur,
				compo: [],
				idRapport
			};

			this.updateRapport.newProductions.push(angular.copy(newProduction));

			newProduction.compo.push(newProduction);

			for (var index2 = 0; index2 < ligne.composition.length; index2++) {
				let currentCompo = ligne.composition[index2];
				let newCompo = {
					idProduit: currentCompo.idProduit,
					codeProduit: currentCompo.codeProduit,
					libelleProduit: currentCompo.libelleProduit,
					idSiteProducteur: currentCompo.idProducteur,
					mouvement: 5,
					quantite: (-quantite * currentCompo.pourcent) / 100,
					unite: currentCompo.unite,
					idProduitCompare: currentCompo.idProduit + '_' + currentCompo.idProducteur,
					estSortie: true,
					perte: currentCompo.perte
				};
				if (newCompo.unite != ligne.unite) {
					newCompo.quantite = newCompo.quantite * currentCompo.densite;
				}
				newProduction.compo.push(newCompo);
				this.updateRapport.newProductions.push(newCompo);
			}
			for (var index3 = 0; index3 < ligne.compositionComplementaire.length; index3++) {
				let currentCompo = ligne.compositionComplementaire[index3];
				let newCompoComplementaire = {
					idProduit: currentCompo.idProduit,
					codeProduit: currentCompo.codeProduit,
					libelleProduit: currentCompo.libelleProduit,
					idSiteProducteur: currentCompo.idProducteur,
					mouvement: 5,
					quantite: -currentCompo.pourcent * quantite,
					unite: currentCompo.unite,
					idProduitCompare: currentCompo.idProduit + '_' + currentCompo.idProducteur,
					estSortie: true,
					perte: currentCompo.perte
				};
				newProduction.compo.push(newCompoComplementaire);
				this.updateRapport.newProductions.push(newCompoComplementaire);
			}
			this.updateRapport.newProductionDisplays.push(angular.copy(newProduction));
		}
	}
	handleTransfert(ligne, ligneAvantModif, idRapport) {
		if (ligne.transfertOrigin === ligneAvantModif.transfertOrigin) {
			return;
		}

		ligne.transfertOrigin = ligne.transfertOrigin > 0 ? ligne.transfertOrigin * -1 : ligne.transfertOrigin;

		//on regarde si il y a une ligne avec le même produit
		let ligneExist = this.updateRapport.newTransferts.find(
			(x) => x.idProduit == ligne.idProduit && x.idSiteProducteur == ligne.idProducteur && x.mouvement === 6 && x.idRapport === idRapport
		);

		if (ligneExist) {
			this.removeFromArray(this.updateRapport.newTransferts, ligneExist);
		}

		if (ligne.transfertOrigin !== ligneAvantModif.transfertOrigin) {
			let newTransfert = {
				idProduit: ligne.idProduit,
				codeProduit: ligne.codeProduit,
				libelleProduit: ligne.libelleProduit,
				idSiteProducteur: ligne.idProducteur,
				siteProducteur: ligne.siteProducteur,
				mouvement: 6,
				quantite: ligne.transfertOrigin,
				unite: ligne.unite,
				idProduitCompare: ligne.idProduit + '_' + ligne.idProducteur,
				mouvementsTransfertCible: ligne.mouvementsTransfertCible ? ligne.mouvementsTransfertCible : [],
				id: ligne.id,
				idTransfertOrigin: ligne.idTransfertOrigin,
				idRapport
			};

			this.updateRapport.newTransferts.push(newTransfert);
		}
	}
	handleAjustement(ligne, ligneAvantModif, idRapport) {
		let quantite = ligne.ajustement - (ligneAvantModif.ajustement ? ligneAvantModif.ajustement : 0);

		//on regarde si il y a une ligne avec le même produit
		let ligneExist = this.updateRapport.newAjustements.find(
			(x) => x.idProduit == ligne.idProduit && x.idSiteProducteur == ligne.idProducteur && x.mouvement === 7 && x.idRapport === idRapport
		);

		if (ligneExist) {
			this.removeFromArray(this.updateRapport.newAjustements, ligneExist);
		}

		if (ligne.ajustement !== ligneAvantModif.ajustement) {
			let newAjustement = {
				idProduit: ligne.idProduit,
				codeProduit: ligne.codeProduit,
				libelleProduit: ligne.libelleProduit,
				idSiteProducteur: ligne.idProducteur,
				siteProducteur: ligne.siteProducteur,
				mouvement: 7,
				quantite: quantite,
				unite: ligne.unite,
				idProduitCompare: ligne.idProduit + '_' + ligne.idProducteur,
				idRapport
			};

			this.updateRapport.newAjustements.push(newAjustement);
		}
	}
	removeFromArray(array, element) {
		let index = array.findIndex(
			(x) =>
				x.idProduit === element.idProduit &&
				x.idSiteProducteur === element.idSiteProducteur &&
				x.mouvement === element.mouvement &&
				x.quantite === element.quantite
		);
		if (index > -1) {
			array.splice(index, 1);
		}
	}

	sauvegarder() {
		this.updateRapport.idGroupeSite = this.idSite;
		this.updateRapport.date = this.dateDebut;

		this.isActive =
			this.updateRapport.newAjustements.length > 0 ||
			this.updateRapport.newTransferts.length > 0 ||
			this.updateRapport.newProductions.length > 0;

		if (this.isActive) {
			var _this = this;
			let idProduits = [
				...this.updateRapport.newAjustements.map((x) => x.idProduit + '_' + x.idSiteProducteur),
				...this.updateRapport.newTransferts.map((x) => x.idProduit + '_' + x.idSiteProducteur),
				...this.updateRapport.newProductions.filter((x) => x.mouvement === 3).map((x) => x.idProduit + '_' + x.idSiteProducteur)
			];
			this.updateRapport.idProduits = [...new Set(idProduits)];

			_this.source = this.updateRapport;

			this.$uibModal
				.open({
					template:
						'<stocks-gestion-rapport-activite-save data="$ctrl.source" modal-instance="$ctrl.uibModalInstance"></stocks-gestion-rapport-activite-save>',
					controller: [
						'$uibModalInstance',
						function ($uibModalInstance) {
							var $ctrl = this;
							$ctrl.source = _this.source;
							$ctrl.uibModalInstance = $uibModalInstance;
						}
					],
					controllerAs: '$ctrl',
					size: 'xl',
					backdrop: false
				})
				.result.then(async () => {
					this.updateRapport = {
						idProduits: [],
						newAjustements: [],
						newTransferts: [],
						newProductions: [],
						newProductionDisplays: []
					};
					this.isActive = false;
					await this.getGestionRapport();
				});
		}
	}

	goToMouvementStock(idProduit, idProducteur) {
		const url = this.$state.href('mouvement-stock.list');
		window.open(
			'gestion.html' +
				url +
				`?idSociete=${this.idSociete}&idRegoupementSite=${this.idSite}&idProduit=${idProduit}&idProducteur=${idProducteur}&date=${this.dateDebut}`,
			'_blank'
		);
	}

	opentModalAlert() {
		this.$uibModal.open({
			animation: true,
			size: 'xs',
			backdrop: false,
			windowClass: 'modern-modal',
			template: `                
                    <div class="modal-header modal-info mas-column mas-p-10" style="gap: 5px">
                        <div class="mas-col-fit">
                            <button type="button" class="close" aria-label="Close" ng-click="$ctrl.close()">
                                <span style="color: white" aria-hidden="true">&times;</span>
                            </button>
                            <h4  class="modal-title"><span translate="Attention"></span></h4>
                        </div>
                    </div>
                    <div class="modal-body">
                        <span class="mas-p-10"
                        >Un produit composé ne peut faire de production négative.</span>                      
                    </div>
                    <div class="modal-footer">
                        <div class="mas-col-fit">
                            <div class="mas-row mas-jc-fend">
                                <div class="mas-col-fit">
                                    <button class="btn btn-primary" type="button" ng-click="$ctrl.close()">
                                        <span class="massia-icon-door_exit"></span>
                                        <span class="hidden-xs" translate="FERMER"></span>
                                    </button>                                   
                                </div>
                            </div>
                        </div>
                    </div>`,
			controllerAs: '$ctrl',
			controller: [
				'$uibModalInstance',
				function ($uibModalInstance) {
					this.close = () => $uibModalInstance.dismiss('cancel');
				}
			]
		}).result;
	}

	async refresh() {
		const gestionRapport = this.gestionRapport[0];
		if (gestionRapport.blockRefresh == false) {
			const modalInstance = this.ModalService.confirm({
				modalTitle: this.$translate.instant('STOCKS_GESTION_RAPPORT_ACTIVITE.POPUP_REFRESH_TITLE'),
				modalMsg: gestionRapport.refreshMessage,
				headerClass: 'modal-danger'
			});

			modalInstance.result.then(async () => {
				this.startLoading();
				try {
					await this.StocksGestionRapportActiviteService.refreshMouvements(this.idSite);
					this.notification.success(this.$translate.instant('STOCKS_GESTION_RAPPORT_ACTIVITE.REFRESH_SUCCESS'));
					this.stopLoading();
				} catch (ex) {
					this.notification.error(ex.data);
				} finally {
					await this.getGestionRapport();
					this.stopLoading();
				}
			});
		} else {
			this.ModalService.info({
				modalTitle: this.$translate.instant('STOCKS_GESTION_RAPPORT_ACTIVITE.POPUP_REFRESH_TITLE'),
				modalMsg: gestionRapport.refreshMessage,
				headerClass: 'modal-danger'
			});
		}
	}

	refreshMouvementProgressCtrl() {
		this.progressCurrentValue = '0';
		this.progressMaxValue = '0';
		this.progressLabel = '';
		this.intervalMouv = this.$interval(() => {
			var vm = this;
			if (this.idSite) {
				this.StocksGestionRapportActiviteService.refreshMouvementProgress(this.idSite)
					.then(function (result) {
						vm.progressLabel = result;
						if (result) {
							var parts = result.split('/');
							if (parts.length === 2) {
								vm.progressCurrentValue = parseInt(parts[0].trim(), 10);
								vm.progressMaxValue = parseInt(parts[1].trim(), 10);
								if (vm.progressCurrentValue == vm.progressMaxValue) {
									vm.progressLabel = '';
								}
							}
						}
					})
					.catch(function (error) {
						console.error('Erreur lors de la récupération de la progression:', error);
					});
			}
		}, 40000);
	}

	recalerStockNegatifSecteur(idRapport, idSecteur) {
		// Applique un ajustement positif pour chaque ligne avec un stock final négatif
		if (!Array.isArray(this.gestionRapport)) return;

		this.gestionRapport.forEach((rapport) => {
			if (!Array.isArray(rapport.secteurs)) return;

			rapport.secteurs.forEach((secteur) => {
				if (!Array.isArray(secteur.lignes) || secteur.entete.idRapport !== idRapport || secteur.entete.idSecteur !== idSecteur) {
					return;
				}

				secteur.lignes.forEach((ligne) => {
					if (
						typeof ligne.stockFinal === 'number' &&
						ligne.stockFinal < 0 &&
						ligne.idProduit !== null &&
						ligne.idProduit > 0 &&
						ligne.idProducteur !== null &&
						ligne.idProducteur > 0
					) {
						ligne.ajustement = Math.abs(ligne.stockFinal);

						const modifiedSecteur = this.copySecteurRapport.find(
							(x) => x.entete.idRapport == idRapport && x.entete.idSecteur == idSecteur
						);

						if (!modifiedSecteur) return;

						const modifiedLigne = modifiedSecteur.lignes.find(
							(x) => x.idProduit == ligne.idProduit && x.idProducteur == ligne.idProducteur
						);

						if (!modifiedLigne) return;

						this.handleAjustement(ligne, modifiedLigne, idRapport);
						this.isActive = true;
					}
				});
			});
		});
	}
	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
